const generateHMAC = async (challenge) => {
  const secret = process.env.REACT_APP_LOGIN_SECRET;

  const challengeBytes = Uint8Array.from(atob(challenge), (c) =>
    c.charCodeAt(0)
  );
  const secretKeyBytes = Uint8Array.from(secret, (c) => c.charCodeAt(0));

  console.info(window.crypto);
  console.info(window.crypto.subtle);
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    secretKeyBytes,
    { name: "HMAC", hash: "SHA-1" },
    false,
    ["sign"]
  );

  const signature = await window.crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    challengeBytes
  );
  return btoa(String.fromCharCode(...new Uint8Array(signature)));
};

export default generateHMAC;
